import { useState } from "react";
import { MdEdit } from "react-icons/md";
import { CgEye } from "react-icons/cg";
import styled from "styled-components";
import { FaFileDownload } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { Grid, IconButton, Tooltip, Chip } from "@mui/material";

import { useAxios } from "../../../hooks";
import { Search } from "../../../components";
import pages from "../../../constants/pages";
import { colors } from "../../css components/Style";
import MuiTable from "../../../components/MuiTable";
import Categorize from "./campaign dp list components/Categorize";
import SortBy from "./campaign dp list components/SortBy";
import { alert } from "../../../redux/slices/alertSlice";
import { capitalCase } from "change-case-all";

const Icon = styled(IconButton)`
  border: 1px solid ${colors.purple};
  color: ${colors.purple};
  height: 35px;
  width: 35px;
  margin: 0 5px;
  padding: 0 5px;
  &:hover {
    border: 1px solid ${colors.purple};
    box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;
  }
`;

export default function List({
  campaigns,
  component,
  loading,
  setPage,
  setSearchKey,
  setSortBy,
  setCategorize,
  categorize,
  sortBy,
  page,
}) {
  let columns = [
    { name: "campaign_name", label: "Campaign Name" },
    {
      name: "camapign_period",
      label: "Campaign Period",
    },
    {
      name: "conversion_type",
      label: "Conversion Type",
    },
    {
      name: "user_Count",
      label: "User Count",
    },
    {
      name: "budget",
      label: "Campaign Budget",
    },
    { name: "status", label: "Status" },
    {
      name: "action",
      label: "Action",
    },
  ];

  const renderCell = (col, value, row) => {
    if (col.name === "budget") {
      return row.min_budget + "-" + row.max_budget;
    }

    if (col.name === "camapign_period") {
      return (
        convertDate(row.start_duration) + " - " + convertDate(row.end_duration)
      );
    }

    if (col.name === "status") {
      let color;
      let background;
      if (value === "REQUESTED" || value === "CREATED") {
        color = colors.warning;
        background = colors.lightWarning;
      }

      if (
        value === "OFFER_ACCEPTED" ||
        value === "ACTIVE" ||
        value === "ACCEPTED" ||
        value === "READY"
      ) {
        color = colors.success;
        background = colors.lightSuccess;
      }

      if (value === "INITIATED") {
        color = colors?.purple;
        background = colors.lightPurple;
      }

      if (
        value === "REJECTED" ||
        value === "Expired" ||
        value === "FAILED" ||
        value === "MISSED"
      ) {
        color = colors.error;
        background = colors.lightError;
      }

      return (
        <Chip
          style={{
            fontSize: "13px",
            backgroundColor: background,
            color: color,
          }}
          label={capitalCase(value.replace(/_/g, " "))}
        />
      );
    }

    if (col.name === "action") {
      return (
        <div>
          <Tooltip title="View Campaign">
            <Icon>
              <CgEye
                onClick={() => handleRedirection(row, "view")}
                style={{ height: "20px", width: "20px" }}
              />
            </Icon>
          </Tooltip>

          {component === "" &&
            row.status !== "ACTIVE" &&
            row.status !== "INITIATED" &&
            row.isEditable && (
              <Tooltip title="Edit Campaign">
                <Icon onClick={() => handleRedirection(row, "edit")}>
                  <MdEdit style={{ height: "20px", width: "20px" }} />
                </Icon>
              </Tooltip>
            )}
        </div>
      );
    }

    return value; // default
  };

  const navigate = useNavigate();

  function convertDate(d) {
    let date = new Date(d);

    return (
      date.getDate() + "." + (date.getMonth() + 1) + "." + date.getFullYear()
    );
  }

  function handleRedirection(campaign, mode) {
    if (component === "request") {
      navigate(
        pages.campaignRequestDetails.route +
          campaign.sender_campaignId +
          "?brandID=" +
          campaign.sender_brandId +
          "&mode=" +
          mode
      );
    }

    if (component === "accepted") {
      navigate(
        pages.campaignAcceptedDetails.route +
          campaign.campaign_id +
          "?brandID=" +
          campaign.brand_id +
          "&mode=" +
          mode
      );
    }

    if (component === "") {
      navigate(
        pages.campaignDetails.route + campaign.campaign_id + "?mode=" + mode
      );
    }
  }

  return (
    <Grid container spacing={8}>
      <Grid size={12} />
      <Grid size={12}>
        <MuiTable
          loading={loading}
          components={[
            <ToolBar
              page={page}
              sortBy={sortBy}
              categorize={categorize}
              setCategorize={setCategorize}
              setSortBy={setSortBy}
              setPage={setPage}
              setSearchKey={setSearchKey}
            />,
          ]}
          columns={columns}
          renderCell={renderCell}
          data={campaigns}
        />
      </Grid>
    </Grid>
  );
}

export function ToolBar({
  categorize,
  setPage,
  setSearchKey,
  setCategorize,
  setSortBy,
  sortBy,
  page,
}) {
  const axios = useAxios();
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);

  const { activeBrand } = useSelector((state) => state.memberDetails);

  function handleDownloadReport() {
    setLoading(true);
    axios({
      url:
        "/contributer/consolidated/report?brandId=" +
        activeBrand.ID +
        "&campaignStatus=running" +
        `&page=${page.page}&limit=10`,
      disableRedirect: true,
    }).then((response) => {
      if (response.status) {
        dispatch(
          alert({
            type: "success",
            message: "Report was successfully downloaded.",
          })
        );

        window.location.href = response?.data?.reportUrl;
      }
      setLoading(false);
    });
  }

  return (
    <div
      style={{
        width: "100%",
        display: "flex",
        justifyContent: "space-between",
      }}
    >
      <div style={{ display: "flex", gap: "10px" }}>
        <Search setPage={setPage} setSearchKey={setSearchKey} />

        <Categorize
          categorize={categorize}
          setCategorize={setCategorize}
          setPage={setPage}
          setSortBy={setSortBy}
        />

        {categorize === "REQUESTED" && (
          <SortBy
            sortBy={sortBy}
            setCategorize={setCategorize}
            setPage={setPage}
            setSortBy={setSortBy}
          />
        )}
      </div>

      <div style={{ margin: "auto 0px" }}>
        <Tooltip title="Download Report">
          <Icon loading={loading} onClick={handleDownloadReport}>
            <FaFileDownload />
          </Icon>
        </Tooltip>
      </div>
    </div>
  );
}
